import { random } from '../../functions.js';

//////////////////////////////////////////////
// make the canvas and append it!
const initAudioCanvas = () => {

  // setup canvas
  const cnvElm = document.createElement('canvas');
  const cnvWrapper = document.getElementById('peakFile');
  const w = cnvWrapper.offsetWidth;
  cnvElm.id = 'audioCanvas';
  cnvElm.height = 60; // must set this!
  cnvElm.width = w; // must set this!
  const ctx = cnvElm.getContext('2d');

  ctx.fillStyle = '#F6F6F6';
  ctx.fillRect(0, 0, cnvElm.width, cnvElm.height);

  // wrapper
  cnvWrapper.appendChild(cnvElm);

  return ctx;
}


//////////////////////////////////////////////
// draw the sound profile in the canvas!
const drawAudioImg = (ctx, peakfile) => {
  console.log("peakfile:", peakfile);
  const peakElm = document.getElementById('peakFile');
  peakElm.style.backgroundImage = 'url(' +  '../images/peakfiles/' + peakfile + ')';
}


////////////////////////////////
export {
  initAudioCanvas, drawAudioImg
}